var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "block" },
      [
        _c("router-link", { attrs: { to: "/user/drills" } }, [
          _c("i", { staticClass: "fas fa-chevron-left" }),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("term.drillList")))]),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c("h1", { staticClass: "title is-4" }, [_vm._v(_vm._s(_vm.titleLabel))]),
    _vm._v(" "),
    _vm.drill
      ? _c("div", { staticClass: "block" }, [
          _vm.answerCount > 0
            ? _c("div", { staticClass: "mt-2" }, [
                _c("label", { staticClass: "has-text-weight-semibold" }, [
                  _vm._v(_vm._s(_vm.$t("term.score"))),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.correctAnswerCount) +
                      " / " +
                      _vm._s(_vm.answerCount)
                  ),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    "(" +
                      _vm._s(_vm.$t("term.accuracyRate")) +
                      ": " +
                      _vm._s(_vm.correctAnswerRate) +
                      " %)"
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "mt-2" }, [
            _c("label", { staticClass: "has-text-weight-semibold" }, [
              _vm._v(_vm._s(_vm.$t("term.spentTime"))),
            ]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm._f("timeFormat")(_vm.spentTime)))]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mt-2" }, [
            _c("label", { staticClass: "has-text-weight-semibold" }, [
              _vm._v(_vm._s(_vm.$t("term.startedAt"))),
            ]),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm._f("dateFormat")(_vm.drill.startedAt))),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mt-2" }, [
            _c("label", { staticClass: "has-text-weight-semibold" }, [
              _vm._v(_vm._s(_vm.$t("term.finishedAt"))),
            ]),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm._f("dateFormat")(_vm.drill.finishedAt))),
            ]),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.answers.length > 0
      ? _c(
          "ul",
          _vm._l(_vm.answers, function (answer) {
            return _c("li", { staticClass: "block" }, [
              _c("p", {
                domProps: { innerHTML: _vm._s(answer.post.postBody) },
              }),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(answer.answerBody))]),
              _vm._v(" "),
              _c(
                "p",
                [
                  _c("correct-status", {
                    attrs: { "is-correct": answer.isCorrect },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("p", [
                _c("label", [_vm._v(_vm._s(_vm.$t("term.spentTime")))]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm._f("timeFormat")(answer.spentTime))),
                ]),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(_vm._s(_vm._f("dateFormat")(answer.finishedAt))),
              ]),
              _vm._v(" "),
              _c(
                "p",
                [
                  _c(
                    "router-link",
                    { attrs: { to: `/user/answers/${answer.userAnswerId}` } },
                    [_vm._v(_vm._s(_vm.$t("term.showExplanation")))]
                  ),
                ],
                1
              ),
            ])
          }),
          0
        )
      : _vm.isLoading !== false
      ? _c("div", [_c("p", [_vm._v(_vm._s(_vm.$t('msg["Data is empty"]')))])])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }